import { Component, OnInit } from '@angular/core';
import { Plan, PlanHumanized } from '../../../core/models/common/plan';
import { fromStore } from 'angular/app/core/store';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-pricing-page',
  template: `
    <div class="container pt-10 xl:pt-20">
      <app-plan-calculator />

      <app-plans class="mt-20 block xl:mt-40"></app-plans>

      <div class="mt-20 xl:mt-40">
        <h2 class="text-center">Comparateur des options</h2>

        <div class="sticky top-14 mt-16 bg-white px-6 pb-3 lg:px-16 lg:pt-16">
          <div
            class="grid grid-cols-2 items-end font-bold uppercase md:grid-cols-4"
          >
            <div class="hidden md:block md:pl-6">Option</div>
            <div class="hidden text-center md:block">
              <img
                src="/assets/img/free-plan.svg"
                alt="Plan gratuit"
                class="mx-auto w-28"
              />
            </div>
            <div class="hidden text-center md:block">
              <img
                src="/assets/img/annual-subscription.svg"
                alt="Abonnement annuel"
                class="mx-auto w-28"
              />
            </div>
            <div class="hidden text-center md:block">
              <img
                src="/assets/img/commission-based.svg"
                alt="À la commission"
                class="mx-auto w-28"
              />
            </div>
          </div>
        </div>

        <div class="md:hidden">
          <app-plan-selector></app-plan-selector>
        </div>

        <div class="mb:mt-0 space-y-4 bg-white pt-10 pb-4 lg:px-16 lg:pb-16">
          @for (featureKey of featureKeys; track featureKey; let i = $index) {
            <div
              class="grid grid-cols-2 items-center gap-2 rounded-3xl px-4 md:grid-cols-4 md:gap-0 md:rounded-full md:px-6"
              [ngClass]="{
                'bg-light py-4': i % 2 === 0,
              }"
            >
              <div class="col-span-1">{{ featureKey }}</div>
              @for (plan of plansOptions; track plan) {
                <div
                  class="col-span-1 hidden text-center md:block"
                  [innerHTML]="content(featureKey, plan.value)"
                >
                </div>
              }
              <div
                class="col-span-1 text-center md:hidden"
                [innerHtml]="content(featureKey, selectedPlan$ | async)"
              >
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <app-spacer size="20"></app-spacer>
  `,
  styles: [],
  standalone: false,
})
export class PricingPageComponent implements OnInit {
  plansOptions = Object.values(Plan).map((plan) => ({
    label: PlanHumanized[plan],
    value: plan,
  }));
  selectedPlan$: Observable<Plan> = this.store.select(fromStore.selectPlan);
  features = {
    Utilisateurs: {
      [Plan.Free]: 'illimité',
      [Plan.AnnualSubscription]: 'illimité',
      [Plan.CommissionBased]: 'illimité',
    },
    'Réservations internes': {
      [Plan.Free]: 'illimité',
      [Plan.AnnualSubscription]: 'illimité',
      [Plan.CommissionBased]: 'illimité',
    },
    'Locations payantes': {
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    'Facturation automatisée': {
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    'Gestion complète des salles et des équipements': {
      [Plan.Free]: true,
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    'Réservations récurrentes': {
      [Plan.Free]: true,
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    'Notficiations aux collaborateurs': {
      [Plan.Free]: true,
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    "Locations d'équipements en supplément": {
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    'Groupes tarifaires': {
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    "Conditions d'annulation automatisées": {
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    'Modèles de communication': {
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    'Codes promotionnels': {
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    'Authentification à 2 facteurs': {
      [Plan.Free]: true,
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    'Groupes de salles / Salles liées': {
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    'Intégration dormakaba': {
      [Plan.AnnualSubscription]: 'en supplément',
      [Plan.CommissionBased]: 'en supplément',
    },
    'Options de réservation': {
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
    Support: {
      [Plan.AnnualSubscription]: true,
      [Plan.CommissionBased]: true,
    },
  };

  get featureKeys(): string[] {
    return Object.keys(this.features);
  }

  constructor(private store: Store) {}

  ngOnInit(): void {}

  content(key: string, plan: string | Plan) {
    if (this.features[key][plan] === true) {
      return '<i class="fa-solid fa-circle-check text-primary-500"></i>';
    } else if (typeof this.features[key][plan] === 'string') {
      return this.features[key][plan];
    } else {
      return '-';
    }
  }
}
